import Icon from 'veui/components/Icon'

Icon.register({
  'file-checked': {
    paths: [
      {
        d: 'M416 704a32 32 0 01-32 32H128a32 32 0 01-32-32V64a32 32 0 0132-32h512a32 32 0 0132 32v289a32 32 0 01-64 0V96H160v576h224a32 32 0 0132 32zM256 256h256a32 32 0 000-64H256a32 32 0 000 64zm0 160h257a32 32 0 000-64H256a32 32 0 000 64zm466.6 38a32 32 0 00-44.6 7.4L543.37 649.83l-69.77-93a32 32 0 00-51.2 38.4l96 128A32 32 0 00544 736h.37A32 32 0 00570 722.6l160-224a32 32 0 00-7.4-44.6z'
      }
    ],
    width: '768',
    height: '768'
  }
})
